// ignore-string-externalization

import React from 'react';
import dynamic from 'next/dynamic';
import { NextPage, NextPageContext } from 'next';
import { NotFound } from '../../../features/Layout';

const Template = dynamic(
  async () =>
    // eslint-disable-next-line import/dynamic-import-chunkname
    (await import('../../../features/Template')).Template,
  { ssr: false },
);

const TypeformPage: NextPage<{
  template?: any;
  formId?: string;
  preview?: boolean;
}> = ({ template, formId, preview }) => {
  if (!formId) {
    return <NotFound />;
  }

  return (
    <Template
      {...template}
      formId={formId}
      preview={preview}
      requiredFeatureFlag={false}
      forceLogin={false}
    />
  );
};

// any Marquee forms translated to different languages other than English
const MARQUEE_FORMS: { [key: string]: string } = {
  br: 'MRJVaNUr',
  es: 'sa4Wu0py',
};

TypeformPage.getInitialProps = async ({
  preview = false,
  query,
}: NextPageContext & { preview?: boolean; activeSession?: boolean }) => {
  const slug = query.urlSlug as string;
  const formId = MARQUEE_FORMS[slug];
  return {
    template: {
      contentType: 'typeformPage',
    },
    formId,
    preview,
  };
};

export default TypeformPage;
